<template>
  <div>
    <modal-alterar-data-envio ref="modalAlterarDataEnvio" @dataEnvioAlterada="buscarBrindes"
                                                          :brindes="brindesSelecionados" />
    <div class="tab-pane fade show active" id="pills-brindes" role="tabpanel" aria-labelledby="pills-brindes-tab">
      <div class="text-center text-md-left mb-3">
        <form v-on:submit.prevent="buscarBrindes">
          <div class="form-inline justify-content-center justify-content-md-start">
            <a class="btn btn-secondary mr-3 mb-2 mb-md-0" v-if="this.brindesSelecionados.length > 0" @click="modalAlterarDataEnvio"><i class="far fa-calendar-alt"></i> Alterar data de envio</a>&#32;
            <a class="btn btn-secondary mr-3 mb-2 mb-md-0" v-if="this.brindesSelecionados.length > 0" @click="exportar"><i class="fas fa-file-export"></i> Exportar linhas</a>&#32;
            <b-link v-b-toggle.collapse-filter class="btn btn-secondary mr-3 mb-2 mb-md-0"><i class="fas fa-filter"></i> Filtrar lista</b-link>
          </div>
        </form>
      </div>
    </div>
    <b-collapse id="collapse-filter" class="filtros mt-3">
      <b-card>
        <form v-on:submit.prevent="buscarBrindes">
          <div class="row align-items-center">
            <div class="col-12 col-md-11">
              <div class="row">
                <div class="col-12 col-md-3">
                  <div class="form-group">
                    <label>Busca</label>
                    <input type="text" class="form-control" id="inputBusca" placeholder="Busque por um usuário ou e-mail" style="width:442px;max-width:100%" v-model="filtro.termo">
                  </div>
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-group">
                    <label>Status</label>
                    <select class="form-control" v-model="filtro.status">
                      <option value="">Selecione</option>\
                      <option value="Todos">Todos</option>
                      <option value="Enviado">Enviado</option>
                      <option value="Pendente">Pendente</option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-group">
                    <label>Brinde</label>
                    <select class="form-control" v-model="filtro.recompensa_id">
                    <option value="">Selecione</option>
                      <option v-for="recompensa in recompensas" :value="recompensa.id" v-bind:key="recompensa.id">{{ recompensa.descricao }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-md-5">
                  <div class="form-group">
                    <label><input type="checkbox" v-model="filtro.createdDate" /> Filtrar por data de disponibilização</label>
                    <date-range-picker
                      v-if="filtro.createdDate"
                      ref="picker"
                      :auto-apply="true"
                      opens="center"
                      v-model="filtro.createdDateRange"
                      :locale-data="dateRangeLocale"
                      :ranges="filtrosDateRangePredefinidos">
                    </date-range-picker>
                  </div>
                </div>
                <div class="col-12 col-md-5">
                  <div class="form-group">
                    <label><input type="checkbox" v-model="filtro.validDate"/> Filtrar por data de envio</label>
                    <date-range-picker
                      v-if="filtro.validDate"
                      ref="picker"
                      :auto-apply="true"
                      opens="center"
                      v-model="filtro.validDateRange"
                      :locale-data="dateRangeLocale"
                      :ranges="filtrosDateRangePredefinidos">
                    </date-range-picker>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-1">
              <button type="submit" class="btn-primary btn-filtros-busca"><i class="fas fa-search"></i></button>
            </div>
          </div>
        </form>
      </b-card>
    </b-collapse>
    <p class="text-right mt-3" v-if="quantidade"><strong>{{ quantidade }}</strong> itens</p>
    <div class="table-responsive tabela-brindes mt-2 position-relative" v-if="brindes.length">
      <table class="table" ref="resultadoTabelaBrindes">
        <thead>
          <tr>
            <th><input type="checkbox" v-model="selectAll" value="true"/></th>
            <!-- <th>ID</th> -->
            <th>User ID</th>
            <th>Nome</th>
            <th>E-mail</th>
            <th>Telefone</th>
            <th>CPF</th>
            <th>Brinde</th>
            <th>Milestones</th>
            <th>Endereço</th>
            <th>Data brinde disponibilizado</th>
            <th>Data de envio</th>
            <th>Status</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(brinde, index) in brindes">
            <tr v-if="brinde.user">
              <td><input type="checkbox" @click="alteraSelecionado(brinde)"  v-model="brindesSelecionados" :value="brinde"/></td>
              <!-- <td>{{ brinde.id }}</td> -->
              <td>{{ brinde.user_id }}</td>
              <td>{{ brinde.user ? brinde.user.name : 'Usuário não encontrado' }}</td>
              <td>{{ brinde.user ? brinde.user.email :  'Usuário não encontrado' }}</td>
              <td>{{ brinde.user ? brinde.user.telefone :  'Usuário não encontrado' }}</td>
              <td>{{ brinde.user ? brinde.user.cpf :  'Usuário não encontrado' }}</td>
              <td>{{ brinde.recompensa.descricao }}</td>
              <td>{{ brinde.recompensa.milestones }}</td>
              <td>
                  <span :ref="'endereco' + index">{{ brinde.user && brinde.user.rua ? brinde.user.rua + '...' : 'Endereço não encontrado' }}</span>
                  <a v-if="brinde.user && brinde.user.rua" @click="copiarEndereco(brinde.user, index)" v-b-tooltip.hover :title="copiarEnderecoHover">
                      <i class="ml-1 mdi mdi-content-copy" />
                  </a>
              </td>
              <td>{{ brinde.dataDisponibilizacao }}</td>
              <td>
                  <template v-if="!brinde.data_envio_recompensa && !brinde.mostrarCalendario">
                      {{ 'Preencher' }}
                      <a @click="brinde.mostrarCalendario = !brinde.mostrarCalendario">
                          <i class="mdi mdi-pencil" />
                      </a>
                  </template>
                  <template v-if="brinde.data_envio_recompensa && !brinde.mostrarCalendario">
                      {{ brinde.dataEnvio }}
                      <a @click="brinde.mostrarCalendario = !brinde.mostrarCalendario">
                          <i class="mdi mdi-pencil" />
                      </a>
                  </template>
                  <b-form-datepicker
                    v-if="brinde.mostrarCalendario"
                    :placeholder="brinde.data_envio_recompensa ? dataInicialCalendarioPlaceholder(brinde.data_envio_recompensa) : 'Nenhuma data selecionada'"
                    label-no-date-selected="Nenhuma data selecionada"
                    label-help="Use as setas do teclado para navegar entre as datas"
                    v-model="brinde.dataEnvio"
                    :initial-date="brinde.data_envio_recompensa ? dataInicialCalendario(brinde.data_envio_recompensa) : null"
                    @input="atualizarDataEnvio(brinde)"
                  >
                  </b-form-datepicker>
              </td>
              <td>
                <span
                  class="badge" :class="{ 'bg-success': brinde.data_envio_recompensa, 'bg-danger': !brinde.data_envio_recompensa }">
                  {{ brinde.data_envio_recompensa ? 'Enviado' : 'Pendente' }}
                </span>
              </td>
              <td>
                  <div class="d-flex align-items-center justify-content-center">
                      <a @click="exportarApenasUm(brinde)" v-b-tooltip.hover title="Exportar">
                          <i class="mdi mdi-cog" />
                      </a>
                  </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
      <transition name="fade">
        <div class="btn-top text-center d-block" v-if="scrolled">
          <a href="javascript:void(0)" @click="scrollToTop"><i class="fas fa-chevron-circle-up"></i>ir para o topo</a>
        </div>
      </transition>
    </div>
    <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
      <div slot="no-results">Sua busca não retornou resultados</div>
      <div slot="no-more"></div>
    </infinite-loading>
  </div>
</template>
<script>
import BrindesApi from '@/api/brindes-api'
import InfiniteLoading from 'vue-infinite-loading'
import DateUtils from '@/core/util/date-utils'
import Swal from 'sweetalert2'
import ResponseUtils from '@/core/util/response-utils'
import ModalAlterarDataEnvio from '@/modules/Brindes/components/ModalAlterarDataEnvio'
import moment from 'moment'
import DateRangePicker from 'vue2-daterange-picker/src/components/DateRangePicker'

export default {
  name: 'ListaBrindes',
  components: {
    InfiniteLoading,
    ModalAlterarDataEnvio,
    DateRangePicker
  },
  data () {
    return {
      pagina: 1,
      quantidade: 0,
      brindes: [],
      dataEnvio: null,
      infiniteId: new Date(),
      scrolled: false,
      recompensas: [],
      filtro: {
        termo: null,
        status: '',
        recompensa_id: '',
        createdDate: false,
        validDate: false,
        createdDateRange: {
          startDate: DateUtils.formatDate(DateUtils.create().subtract(1, 'month').toDate()),
          endDate: DateUtils.formatDate(new Date())
        },
        validDateRange: {
          startDate: DateUtils.formatDate(DateUtils.create().subtract(1, 'month').toDate()),
          endDate: DateUtils.formatDate(DateUtils.create().add(1, 'month').toDate())
        }
      },
      filtrosDateRangePredefinidos: {
        'Esta semana': [moment().startOf('week'), moment().endOf('week')],
        'Última semana': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
        'Este mês': [moment().startOf('month'), moment().endOf('month')],
        'Último mês': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        'Este ano': [moment().startOf('year'), moment().endOf('year')]
      },
      dateRangeLocale: {
        direction: 'ltr',
        format: 'DD/MM/YYYY',
        separator: ' - ',
        daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        monthNames: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
      },
      copiarEnderecoHover: 'Copiar endereço',
      shiftPressed: false,
      brindesSelecionados: [],
      selectAll: false
    }
  },
  mounted () {
    BrindesApi.listarRecompensas().then(data => {
      this.recompensas = data
    })
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  watch: {
    selectAll: function (value) {
      if (value) {
        this.brindesSelecionados = this.brindes
      } else {
        this.brindesSelecionados = []
      }
    }
  },
  methods: {
    handleScroll: function (event) {
      this.scrolled = window.scrollY > 100
    },
    handleKeyDown: function (event) {
      if (event.key === 'Shift') {
        this.shiftPressed = true
      }
    },

    handleKeyUp: function (event) {
      if (event.key === 'Shift') {
        this.shiftPressed = false
      }
    },
    scrollToTop: function () {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' })
    },
    buscarBrindes: function () {
      this.quantidade = 0
      this.pagina = 1
      this.infiniteId = new Date()
      this.brindes = []
      this.brindesSelecionados = []
    },
    alteraSelecionado: function (brinde) {
      if (this.shiftPressed && this.ultimoSelecionado) {
        let maiorQueUltimo = (brinde.id > this.ultimoSelecionado.id)
        let novosSelecionados = []
        novosSelecionados = this.questoes.filter(item => {
          if (maiorQueUltimo) {
            return (item.id <= brinde.id) && (item.id >= this.ultimoSelecionado.id)
          } else {
            return (item.id <= this.ultimoSelecionado.id) && (item.id >= brinde.id)
          }
        })
        novosSelecionados.map(brinde => {
          !this.brindesSelecionadas.includes(brinde) && this.brindesSelecionadas.push(brinde)
        })
      }
      this.ultimoSelecionado = brinde
    },
    infiniteHandler: function ($state) {
      BrindesApi.listar(this.pagina, this.filtro).then(data => {
        this.quantidade = data.total
        if (this.pagina <= data.last_page) {
          this.brindes.push(...data.data.map(item => {
            return Object.assign(item, {
              mostrarCalendario: false,
              dataEnvio: item.data_envio_recompensa ? DateUtils.formatDate(item.data_envio_recompensa, 'DD/MM/YYYY') : '',
              dataDisponibilizacao: item.data_disponibilizacao_recompensa ? DateUtils.formatDate(item.data_disponibilizacao_recompensa, 'DD/MM/YYYY') : ''
            })
          }))
          $state.loaded()
          if (this.pagina === data.last_page) {
            $state.complete()
          } else {
            this.pagina += 1
          }
        } else {
          $state.complete()
        }
      })
    },
    atualizarDataEnvio: function (brinde) {
      const loader = this.$loading.show()

      BrindesApi.atualizarDataEnvio(brinde).then(data => {
        loader.hide()
        Swal.fire({
          icon: 'success',
          showCloseButton: true,
          text: 'Data de envio atualizada com sucesso'
        }).then(() => {
          this.buscarBrindes()
        })
      }).catch(error => ResponseUtils.handleError(error))
    },
    concatenarEndereco: function (user) {
      let rua = user.rua ? user.rua : ''
      let numero = user.numero ? ' ' + user.numero : ''
      let complemento = user.complemento ? ', ' + user.complemento : ''
      let bairro = user.bairro ? ', ' + user.bairro : ''
      let cep = user.cep ? ', ' + user.cep : ''
      let cidade = user.cidade ? ', ' + user.cidade : ''
      return rua + numero + complemento + bairro + cep + cidade
    },
    copiarEndereco: function (user) {
      let textArea = document.createElement('textarea')
      textArea.value = this.concatenarEndereco(user)
      document.body.appendChild(textArea)
      textArea.select()
      document.execCommand('copy')
      textArea.remove()
      this.copiarEnderecoHover = 'Copiado'
      setTimeout(() => { this.copiarEnderecoHover = 'Copiar endereço' }, 1000)
      return textArea.value
    },
    statusBrinde: function (status) {
      this.filtro.status = status
    },
    isActive: function (status) {
      return this.filtro.status === status
    },
    exportarApenasUm: function (brinde) {
      this.brindesSelecionados = []
      this.brindesSelecionados.push(brinde)
      this.exportar()
    },
    exportar: function () {
      const loader = this.$loading.show()
      this.brindesSelecionados.map(item => {
        Object.assign(item, {
          endereco: this.copiarEndereco(item.user),
          status: item.data_envio_recompensa ? 'Enviado' : 'Pendente'
        })
      })
      let brinde = {
        'brindes': this.brindesSelecionados
      }
      BrindesApi.exportar(brinde).then(data => {
        loader.hide()
        Swal.fire({
          icon: 'success',
          showCloseButton: true,
          text: 'Linha(s) exportada(s) com sucesso'
        }).then(() => {
          this.download(data)
          this.buscarBrindes()
        })
      }).catch(error => ResponseUtils.handleError(error))
    },
    download: function (data) {
      const blob = new Blob([data], { type: 'text/csv' })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.setAttribute('href', url)
      a.setAttribute('download', 'listaBrindes.csv')
      a.click()
    },
    dataInicialCalendario: function (data) {
      return DateUtils.formatDate(data, 'YYYY-MM-DD')
    },
    dataInicialCalendarioPlaceholder: function (data) {
      return DateUtils.formatDate(data, 'DD/MM/YYYY')
    },
    modalAlterarDataEnvio: function () {
      this.$nextTick(() => {
        this.$refs.modalAlterarDataEnvio.show()
      })
    }
  }
}
</script>
